<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-4">
                        <div style="padding-top:15px;">
                            <a href="" onclick="history.back(-1);return false;" class="link_1" style="font-size:20px;">
                                <i class="bi bi-chevron-left head-btn"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col text-center">
                        <div style="padding-top:20px; ">
                            <b>通知設定</b>
                        </div>
                    </div>
                    <div class="col-4 text-end">
                        <div style="display: inline-flex;">
                            <a class="libere-header-menu text-center" href="/info" style="text-decoration:none;">
                                <div class="" style="color:#cdcdcd;padding-top:7px;">
                                    <svg style="height:25px;width:25px;fill:#cdcdcd;">
                                        <use xlink:href="/images/bell.svg#bell"></use>
                                    </svg>
                                    <div class="text-nowrap" style="font-size: 8px;">
                                        通知
                                    </div>
                                </div>
                            </a>
                            <div style="width:15px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br />
            <div class="container" style="margin-top:40px;">
                <div class="row">
                    <div class="col">
                        <div style="padding:0 10px;">
                            <div style="font-size:12px;padding:10px 0;color:#999;">
                                メールアドレス通知
                            </div>
                            <div style="background:#fff;border-radius:10px;width:100%;">
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        マッチング
                                    </div>
                                    <div class="col-2 text-end">
                                        <div v-if="user.is_notification_matching" style="color:#6B4EFF;">ON</div>
                                        <div v-else style="color:#cdcdcd">OFF</div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="user.is_notification_matching" v-on:change="setUsers()">
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        いいね！
                                    </div>
                                    <div class="col-2 text-end">
                                        <div v-if="user.is_notification_good" style="color:#6B4EFF;">ON</div>
                                        <div v-else style="color:#cdcdcd">OFF</div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="user.is_notification_good" v-on:change="setUsers()">
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        新規メッセージ
                                    </div>
                                    <div class="col-2 text-end">
                                        <div v-if="user.is_notification_message" style="color:#6B4EFF;">ON</div>
                                        <div v-else style="color:#cdcdcd">OFF</div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="user.is_notification_message" v-on:change="setUsers()">
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        足あと
                                    </div>
                                    <div class="col-2 text-end">
                                        <div v-if="user.is_notification_footprint" style="color:#6B4EFF;">ON</div>
                                        <div v-else style="color:#cdcdcd">OFF</div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="user.is_notification_footprint" v-on:change="setUsers()" disabled
                                                v-if="user.is_limited">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="user.is_notification_footprint" v-on:change="setUsers()" v-else>
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        Lunaからの案内
                                    </div>
                                    <div class="col-2 text-end">
                                        <div v-if="user.is_notification_luna" style="color:#6B4EFF;">ON</div>
                                        <div v-else style="color:#cdcdcd">OFF</div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="user.is_notification_luna" v-on:change="setUsers()">
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div style="font-size:12px;padding:10px 0;color:#999;">
                                webプッシュ通知
                            </div>
                            <div style="background:#fff;border-radius:10px;width:100%;">
                                <!-- 通知状態メッセージ -->
                                <div style="padding:15px;">
                                    <div style="font-size:12px;padding:0 0 10px 0;color:#666;">
                                        Webプッシュ通知とは、Webブラウザを経由してPCやスマートフォンにプッシュ通知を送信する機能です（iOS/iPadOS 16.4以降）。
                                    </div>
                                    <div class="text-center" style="padding:10px;background:#f8f8f8;border-radius:8px;font-size:14px;">
                                        <span v-if="pushNotificationEnabled" style="color:#6B4EFF;font-weight:bold;">
                                            ✓ {{ notificationStatusText }}
                                        </span>
                                        <span v-else-if="isIOSBrowser" style="color:#ff9800;">
                                            {{ notificationStatusText }}
                                        </span>
                                        <span v-else style="color:#666;">
                                            {{ notificationStatusText }}
                                        </span>
                                    </div>
                                </div>

                                <!-- プッシュ通知有効化トグル -->
                                <div class="row" @click="togglePushNotification"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;cursor:pointer;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        プッシュ通知を有効にする
                                    </div>
                                    <div class="col-2 text-end">
                                        <div v-if="pushNotificationEnabled" style="color:#6B4EFF;">ON</div>
                                        <div v-else style="color:#cdcdcd">OFF</div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" v-model="pushNotificationEnabled"
                                                @click.stop="togglePushNotification">
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>

                                <!-- 通知タイプ設定（将来の拡張用） -->
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        マッチング
                                        <span class="badge bg-secondary" style="margin-left:8px;font-size:10px;">開発中</span>
                                    </div>
                                    <div class="col-2 text-end" style="color:#cdcdcd;">
                                        開発中
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" disabled>
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        いいね！
                                        <span class="badge bg-secondary" style="margin-left:8px;font-size:10px;">開発中</span>
                                    </div>
                                    <div class="col-2 text-end" style="color:#cdcdcd;">
                                        開発中
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" disabled>
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        新規メッセージ
                                        <span class="badge bg-secondary" style="margin-left:8px;font-size:10px;">開発中</span>
                                    </div>
                                    <div class="col-2 text-end" style="color:#cdcdcd;">
                                        開発中
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" disabled>
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;border-bottom: 1px solid #f2f2f2;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        足あと
                                        <span class="badge bg-secondary" style="margin-left:8px;font-size:10px;">開発中</span>
                                    </div>
                                    <div class="col-2 text-end" style="color:#cdcdcd;">
                                        開発中
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" disabled>
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                                <div class="row"
                                    style="padding: 20px 0 12px 0px;margin-right: 0px;margin-left: 0px;">
                                    <div class="col-1">
                                    </div>
                                    <div class="col">
                                        Lunaからの案内
                                    </div>
                                    <div class="col-2 text-end">
                                        <div v-if="pushNotificationEnabled" style="color:#6B4EFF;">ON</div>
                                        <div v-else style="color:#cdcdcd">OFF</div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-1" style="padding-top: 3px;">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" v-model="pushNotificationEnabled" disabled>
                                        </div>
                                    </div>
                                    <div class="col-1">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
import { requestPermissionAndGetToken } from '../../lib/requestPermissionAndGetToken';
import { isIOSSafari, isPWAInstalled, getNotificationPermission, isWebPushSupported } from '../../lib/deviceDetection';

export default {
    data() {
        return {
            user: [],
            setinit: false,
            pushNotificationEnabled: false,
            isIOSBrowser: false,
            fcmToken: null,
        };
    },
    computed: {
        canEnablePushNotification() {
            // iOS Safariでブラウザの場合は、ホーム画面追加が必要
            return isWebPushSupported();
        },
        notificationStatusText() {
            if (this.pushNotificationEnabled) {
                return 'プッシュ通知が有効です';
            }
            if (this.isIOSBrowser) {
                return 'ホーム画面に追加して通知を有効にする';
            }
            if (!isWebPushSupported()) {
                return 'このブラウザでは通知がサポートされていません';
            }
            return '通知を有効にする';
        }
    },
    methods: {
        async fetchUsers() {
            let response = await axios.get("/api/user/status")
                .then((response) => {
                    this.user = response.data.user
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    }
                })
        },
        async setUsers() {
            let response = await axios
                .post("/api/user/mod", {
                    user: this.user,
                    type: "29",
                })
                .then((response) => {
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('ユーザー情報の変更に失敗しました。');
                    }
                })
        },
        checkPushNotificationStatus() {
            // デバイス環境チェック
            this.isIOSBrowser = isIOSSafari() && !isPWAInstalled();

            // 通知許可状態をチェック
            const permission = getNotificationPermission();
            this.pushNotificationEnabled = permission === 'granted';

            // FCMトークンの取得状態をチェック
            this.fcmToken = localStorage.getItem('fcm_token');
        },
        async togglePushNotification() {
            if (this.pushNotificationEnabled) {
                // 通知を無効化（実際にはブラウザ設定で無効化する必要がある）
                this.$showErrorToast('通知を無効にするには、ブラウザの設定から変更してください。');
                return;
            }

            try {
                // 通知許可をリクエスト
                const token = await requestPermissionAndGetToken();

                if (token) {
                    // FCMトークンをサーバーに送信
                    await this.saveFCMToken(token);

                    this.pushNotificationEnabled = true;
                    this.fcmToken = token;
                    localStorage.setItem('fcm_token', token);

                    this.$showSuccessToast('プッシュ通知を有効にしました');
                } else {
                    this.$showErrorToast('通知許可が拒否されました');
                }
            } catch (error) {
                console.error('[Notification] Error enabling push notification:', error);
                this.$showErrorToast('プッシュ通知の有効化に失敗しました');
            }
        },
        async saveFCMToken(token) {
            try {
                await axios.post('/api/fcm-token', {
                    fcm_token: token,
                });
            } catch (error) {
                console.error('[Notification] Error saving FCM token:', error);
                throw error;
            }
        },
    },
    async created() {
        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchUsers()
                        })
                    .catch((error) => {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    })
            }
            else {
                this.fetchUsers()
            }
        }
        else {
            this.fetchUsers()
        }

        // プッシュ通知の状態をチェック
        this.checkPushNotificationStatus();
    },
};
</script>
<style scoped>
.luna-search-header {
    position: fixed;
    width: 540px;
    top: 0;
    z-index: 999999;
    background: #fff;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

.form-check-input:checked {
    background-color: #6B4EFF;
    border-color: #6B4EFF;
}

@media (max-width: 576px) {

    .luna-header-box {
        width: 100%;
    }

    .luna-search-header {
        width: 100%;
    }
}
</style>
